













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { stopBodyScroll,  getBirthday, getBirthSlot } from '@utils/index'
import { Overlay } from 'vant'
import { findIndex, sortBy } from 'lodash'

@Component({
  components: {
    [Overlay.name]: Overlay
  }
})
export default class AgeSelectDialogNoLogin extends Vue {
  @Prop({ default: false }) readonly show!: boolean
  @Prop({ default: () => [] }) readonly list!: any[]
  @Prop({ default: () => null }) readonly selectedBaby!: any

  newList: any[] = []

  babyList() {
    if (this.selectedBaby) {
      //把选中的宝宝排到第一个
      const babyList = sortBy(this.list, item => {
        return item.bid === this.selectedBaby.bid ? 0 : 1
      })
      return babyList
    }
    return this.list
  }

  @Watch('show')
  isShow(val: boolean) {
    if (val) {
      this.newList = this.babyList()
      this.$nextTick(() => {
        //将第一个元素移动到屏幕内
        try {
          const div = this.$refs.age_warpper as HTMLDivElement
          if (div && div.children.length > 0) {
            const a = div.children[0]
            a.scrollIntoView(true)
          }
        } catch (error) {
          console.log(error)
        }
      })
    }
  }

  addBaby() {
    //https://w.cekid.com/vipbabyset-select.html 这个链接返回后会把query的值省去
    location.href = `https://w.cekid.com/vipbabyset-select.html?referer=${location.href + '?addnewbaby=1'}`
  }

  get babyAge() {
    return (baby: any) => {
      if (baby.nickname) {
        return baby.birthdiscribe
      } else {
        const day = getBirthday(baby.birthday)
        if (day < 0) {
          const t = 280 + day - 1 //孕期按40周280天来算
          const a = Math.floor(t / 7)
          const b = t % 7 > 0 ? (t % 7) + '天' : ''
          return `孕${a}周${b}`
        } else {
          //重新计算年纪
          return getBirthSlot(baby.birthday)
        }
      }
    }
  }

  close(e: MouseEvent) {
    const target = e.target as HTMLElement
    if (target.className === 'wrapper') {
      this.$emit('hide')
    }
  }
  @Watch('show')
  onChangeShow(val: boolean) {
    stopBodyScroll(val)
  }
}
